import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import RSVPForm from './components/RSVPForm';
import AdminDashboard from './components/AdminDashboard';
import ThankYou from './components/ThankYou';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-elegant-gray">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/rsvp" element={<RSVPForm />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


